import React, { useEffect, useState } from 'react';
import { Descriptions, message, Button } from 'antd';
import axiosInstance from '../utils/axiosInstance';
import { useParams, useNavigate } from 'react-router-dom';
import { config } from '../utils';

interface OfficerDetailsProps {}

interface Officer {
    id: string;
    officer_name: string;
    email: string;
    phone_number: string;
    img?: string;
    // Add any other fields returned by the endpoint
}

const OfficerDetails: React.FC<OfficerDetailsProps> = () => {
    const { id } = useParams<{ id: string }>();
    const [officer, setOfficer] = useState<Officer | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchOfficerDetails().then((r) => console.log(r)); // eslint-disable-next-line
    }, [id]);

    const fetchOfficerDetails = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(`${config.api.endpoints.officers}/${id}`);
            setOfficer(response.data);
        } catch (error: any) {
            console.error('Error fetching officer details:', error);
            if (error.response) {
                console.error('Response data:', error.response.data);
                console.error('Response status:', error.response.status);
                console.error('Response headers:', error.response.headers);
            }
            message.error('Failed to fetch officer details');
        } finally {
            setLoading(false);
        }
    };

    if (loading || !officer) {
        return <div>Loading...</div>;
    }

    return (
        <div className="p-8">
            <Button onClick={() => navigate('/officers')} style={{ marginBottom: '16px' }}>
                Back to Officers List
            </Button>
            <Descriptions title="Officer Details" bordered>
                <Descriptions.Item label="Officer Name">{officer.officer_name}</Descriptions.Item>
                <Descriptions.Item label="Email">{officer.email}</Descriptions.Item>
                <Descriptions.Item label="Phone Number">{officer.phone_number}</Descriptions.Item>
                <Descriptions.Item label="Profile Image" span={3}>
                    {officer.img ? (
                        <img src={officer.img} alt="Profile" style={{ width: 100 }} />
                    ) : (
                        'N/A'
                    )}
                </Descriptions.Item>
                {/* Add other details if available */}
            </Descriptions>
        </div>
    );
};

export default OfficerDetails;